import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink, useLocation } from "react-router-dom";

import "./Header.css";
import logo from "./img/logo.png";
import logo1 from "./img/logo1.png";

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    if (isHomePage) {
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    } else {
      setScrolled(true);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isHomePage]);

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  const headerClass = isHomePage
    ? expanded
      ? "custom-navbar scrolled"
      : scrolled
      ? "custom-navbar scrolled"
      : "custom-navbar transparent"
    : "custom-navbar default-navbar";

 const currentLogo =
  isHomePage && !scrolled && !expanded ? logo1 : logo;

return (
  <Navbar expand="lg" expanded={expanded} className={headerClass} fixed="top">
    <Container>
      <NavLink to="/" onClick={() => setExpanded(false)} className="logo-link">
        <img className="logo-img" src={currentLogo} alt="logo" />
      </NavLink>

        <Navbar.Toggle
          aria-controls="navbarScroll"
          onClick={() => setExpanded(!expanded)}
          className="custom-toggle"
        />

        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0 mobile-nav">
            <NavLink
              className="nav-link-logo"
              to="/"
              onClick={() => setExpanded(false)}
            >
              Головна
            </NavLink>

            <NavLink
              className="nav-link-logo"
              to="/about"
              onClick={() => setExpanded(false)}
            >
              Про Нас
            </NavLink>

            <NavLink
              className="nav-link-logo"
              to="/contact"
              onClick={() => setExpanded(false)}
            >
              Контакти
            </NavLink>
            <NavLink
              className="nav-link-logo"
              to="/management"
              onClick={() => setExpanded(false)}
            >
              Управління
            </NavLink>
          </Nav>

          <a href="tel:+380678367676" className="nav-link-logo phone-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              height={24}
              width={24}
            >
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5h2C23 6.149 17.852 1 11.5 1v2Zm0 4a5.5 5.5 0 0 1 5.5 5.5h2A7.5 7.5 0 0 0 11.5 5v2ZM9.545 18.238l1.613-2.702 6.508 1.86-.694 5.794-.936-.052a15.971 15.971 0 0 1-7-2.052 16.015 16.015 0 0 1-3.424-2.61 16.014 16.014 0 0 1-2.61-3.423 15.971 15.971 0 0 1-2.052-7l-.052-.937 5.795-.694 1.86 6.508-2.759 1.646a14.092 14.092 0 0 0 3.75 3.662Z"
                clipRule="evenodd"
              />
            </svg>
            +38(067) 836-76-76
          </a>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;